import { MuiTheme, createStyles, makeStyles } from '@kis-technologies/kis-ui';

export const useStyles = makeStyles((theme: MuiTheme) =>
  createStyles({
    createNewUserContainer: {
      display: 'flex',
      flexDirection: 'column',
      margin: '0px auto',
      padding: '0px 20px',
      maxWidth: '1440px',
      height: '100%',
      background: 'white',
      borderRadius: '32px 32px 0px 0px',
      [theme.breakpoints.only('xs')]: {
        padding: '0px 0px'
      }
    },
    createNewUserLogoBlock: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      background: 'transparent',
      padding: '32px 72px 32px 72px',
      margin: '0px 0px 24px 0px',
      [theme.breakpoints.only('xs')]: {
        padding: '32px 20px 0px 20px'
      }
    },
    createNewUserLogo: {
      '& > *': {
        [theme.breakpoints.only('xs')]: {
          height: '40px'
        }
      }
    },
    createNewUserCloseIcon: {
      color: 'rgb(42, 42, 42)',
      '& > * > *': {
        [theme.breakpoints.only('xs')]: {
          width: '30px',
          height: '30px'
        }
      }
    },
    createUserInnerContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: '524px',
      background: 'transparent',
      [theme.breakpoints.only('xs')]: {
        width: '100%',
        padding: '0px 20px 0px 20px'
      }
    },
    createAdminMaintenanceCheckbox: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      height: '68px',
      background: 'transparent',
      padding: '16px 24px 16px 24px',
      border: 'solid 1px',
      borderColor: '#DDDDDD',
      [theme.breakpoints.down('xs')]: {
        height: '42px'
      }
    },
    createNewUserHeading: {
      fontWeight: 600,
      fontSize: '40px',
      textAlign: 'center',
      color: 'black',
      margin: '0px',
      [theme.breakpoints.only('xs')]: {
        fontSize: '34px'
      }
    },
    createNewUserPinBlock: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      marginRight: '-12px',
      marginLeft: '-12px',
      background: 'transparent',
      minWidth: '100%',
      justifyContent: 'space-between',
      [theme.breakpoints.only('xs')]: {
        flexDirection: 'column'
      }
    },
    userFormTextInputBox: {
      height: '130px',
      [theme.breakpoints.down('xs')]: {
        height: '100px',
        display: 'inline-flex',
        flexDirection: 'column'
      },
      '& > * > * > input': {
        [theme.breakpoints.down('xs')]: {
          height: '40px'
        }
      }
    },
    userFormButtonBox: {
      [theme.breakpoints.down('xs')]: {
        height: '100px',
        display: 'inline-flex',
        flexDirection: 'column'
      },
      '& > * > * > input': {
        [theme.breakpoints.down('xs')]: {
          height: '80px'
        }
      },
      margin: '32px 0px 0px 0px',
      [theme.breakpoints.down('xs')]: {
        margin: '22px 0px 0px 0px'
      }
    },
    createVenueBox: {
      background: 'transparent',
      height: '100px',
      minWidth: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      [theme.breakpoints.down('xs')]: {
        height: '110px'
      },
      '& > * > *': {
        [theme.breakpoints.down('xs')]: {
          minWidth: '240px',
          width: '245px'
        }
      }
    },
    createVenueLabel: {
      padding: '16px 24px',
      margin: '0px 0px 10px',
      fontSize: '16px',
      fontWeight: 'bold',
      color: 'black'
    },
    createSendAlertBlock: {
      display: 'flex',
      flexDirection: 'row',
      background: 'transparent',
      height: '68px',
      alignItems: 'center',
      padding: '16px',
      [theme.breakpoints.down('xs')]: {
        padding: '35px 0px 0px 21px',
        height: '14px'
      }
    },
    createUserButtonBox: {
      background: 'transparent',
      margin: '32px 0px 0px 0px',
      [theme.breakpoints.down('xs')]: {
        margin: '22px 0px 0px 0px'
      }
    },
    createUserButton: {
      [theme.breakpoints.down('xs')]: {
        height: '40px',
        width: '100%'
      }
    },
    createPinCode: {
      [theme.breakpoints.down('xs')]: {
        height: '40px',
        width: '100%'
      }
    },
    createUserInputBox: {
      background: 'transparent',
      height: '130px',
      minWidth: '100%',
      [theme.breakpoints.down('xs')]: {
        height: '110px'
      },
      '& > * > * > input': {
        [theme.breakpoints.down('xs')]: {
          height: '40px'
        }
      }
    },
    createUserErrorText: {
      fontSize: '14px',
      color: '#C40B0F',
      marginTop: '10px',
      [theme.breakpoints.down('xs')]: {
        paddingTop: '20px'
      }
    },
    createUserSuccessContainer: {
      display: 'flex',
      flexDirection: 'column',
      width: '644px',
      background: 'transparent',
      gap: '35px',
      [theme.breakpoints.only('xs')]: {
        width: '100%',
        padding: '0px 20px 0px 20px'
      },
      [theme.breakpoints.only('sm')]: {
        padding: '0px 0px 0px 20px'
      }
    },
    createUserSuccessHeader: {
      fontSize: '64px',
      lineHeight: 1,
      fontWeight: 600,
      margin: '0px',
      [theme.breakpoints.only('xs')]: {
        fontSize: '30px',
        textAlign: 'center'
      }
    },
    createUserSuccessSubHeader: {
      fontSize: '16px',
      margin: '0px',
      [theme.breakpoints.only('xs')]: {
        textAlign: 'center'
      }
    },
    createUserViewBox: {
      background: 'transparent',
      flex: 'none',
      minWidth: '100%',
      [theme.breakpoints.only('xs')]: {
        display: 'flex',
        justifyContent: 'center'
      }
    },
    createUserViewButton: {
      width: '334px',
      [theme.breakpoints.down('xs')]: {
        height: '40px',
        width: '100%'
      }
    },

    body: {
      overflow: 'hidden !important'
    }
  })
);
